import { isTabsEnabledForWorkspace } from './components/tab-enablement';

export const isLabelledFeedResourceEnabled = (rovoWorkspace: string | null | undefined): boolean =>
	!!rovoWorkspace && isTabsEnabledForWorkspace(rovoWorkspace);
